var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.configuration")) +
                " > " +
                _vm._s(_vm.$t("sidebar.settings")) +
                "\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("section", { staticClass: "col-12 no-padding" }, [
            _c(
              "div",
              { staticClass: "col-md-12 no-padding" },
              [
                _c("section-header", {
                  attrs: { title: _vm.$t("message.document") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-12 no-padding",
                        staticStyle: { height: "24px" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("message.usedocumentlog")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group col-12 mb-0",
                        staticStyle: { padding: "0" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-row no-padding no-margin" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "form-group col-6",
                                staticStyle: { padding: "0" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "box-input",
                                    staticStyle: { "border-radius": "0" }
                                  },
                                  [
                                    _c(
                                      "vs-checkbox",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          position: "relative",
                                          top: "1px",
                                          left: "-5px"
                                        },
                                        attrs: { color: "#A3CA76" },
                                        model: {
                                          value:
                                            _vm.settings.log_topic.is_active,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.settings.log_topic,
                                              "is_active",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings.log_topic.is_active"
                                        }
                                      },
                                      [
                                        !_vm.settings.log_topic.is_active
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.disabled")
                                                )
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.enabled")
                                                )
                                              )
                                            ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group col-6",
                                staticStyle: {
                                  "padding-left": "0",
                                  "padding-right": "0"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "box-input active",
                                    staticStyle: {
                                      "border-radius": "0px .25rem .25rem 0",
                                      "border-left": "0",
                                      "padding-right": "3px",
                                      display: "flex",
                                      "justify-content": "space-between",
                                      "align-items": "center"
                                    }
                                  },
                                  [
                                    _c("span"),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-light",
                                        staticStyle: {
                                          height: "28px",
                                          "font-size": "11px",
                                          "box-shadow": "none"
                                        },
                                        on: {
                                          click:
                                            _vm.handleOpenLogTipicMasterData
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.managemasterdata",
                                                {
                                                  number:
                                                    _vm.settings.log_topic
                                                      .options.length
                                                }
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-12 no-padding",
                        staticStyle: { height: "24px" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("message.usedocumentattachfile")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group col-12 mb-0",
                        staticStyle: { padding: "0" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-row no-padding no-margin" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "form-group col-12",
                                staticStyle: { padding: "0" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "box-input" },
                                  [
                                    _c(
                                      "vs-checkbox",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          position: "relative",
                                          top: "1px",
                                          left: "-5px"
                                        },
                                        attrs: { color: "#A3CA76" },
                                        model: {
                                          value:
                                            _vm.settings.attach_file.is_active,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.settings.attach_file,
                                              "is_active",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings.attach_file.is_active"
                                        }
                                      },
                                      [
                                        !_vm.settings.attach_file.is_active
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.disabled")
                                                )
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.enabled")
                                                )
                                              )
                                            ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "col-12 no-padding" }, [
            _c(
              "div",
              { staticClass: "col-md-12 no-padding" },
              [
                _c("section-header", {
                  attrs: { title: _vm.$t("apps.purchases.message.potemplate") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-md-12 no-padding",
                            staticStyle: { height: "24px" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("message.fixedsignaturebottom")) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-group col-12 m-0",
                            staticStyle: { padding: "0" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-row no-padding no-margin" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group col-12",
                                    staticStyle: { padding: "0" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "box-input",
                                        staticStyle: { "border-radius": "0" }
                                      },
                                      [
                                        _c(
                                          "vs-checkbox",
                                          {
                                            staticStyle: {
                                              float: "left",
                                              position: "relative",
                                              top: "1px",
                                              left: "-5px"
                                            },
                                            attrs: { color: "#A3CA76" },
                                            model: {
                                              value:
                                                _vm.settings.doc_template
                                                  .is_fixed_signature_bottom,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.settings.doc_template,
                                                  "is_fixed_signature_bottom",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "settings.doc_template.is_fixed_signature_bottom"
                                            }
                                          },
                                          [
                                            _vm.settings.doc_template
                                              .is_fixed_signature_bottom
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.yes")
                                                    )
                                                  )
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("message.no"))
                                                  )
                                                ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 mb-2" }, [
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.$t("apps.pos.message.fontsize"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.settings.doc_template.font_size,
                                    expression:
                                      "settings.doc_template.font_size"
                                  }
                                ],
                                staticClass: "custom-select form-control",
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.settings.doc_template,
                                      "font_size",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { domProps: { value: 50 } }, [
                                  _vm._v("50%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 60 } }, [
                                  _vm._v("60%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 70 } }, [
                                  _vm._v("70%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 80 } }, [
                                  _vm._v("80%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 90 } }, [
                                  _vm._v("90%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 100 } }, [
                                  _vm._v("100%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 110 } }, [
                                  _vm._v("110%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 120 } }, [
                                  _vm._v("120%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 130 } }, [
                                  _vm._v("130%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 140 } }, [
                                  _vm._v("140%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 150 } }, [
                                  _vm._v("150%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 160 } }, [
                                  _vm._v("160%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 170 } }, [
                                  _vm._v("170%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 180 } }, [
                                  _vm._v("180%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 190 } }, [
                                  _vm._v("190%")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 200 } }, [
                                  _vm._v("200%")
                                ])
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 wrapper-doc-demo" }, [
                    _c("div", { staticClass: "wrapper-doc-demo-bg" }, [
                      _c("div", { staticClass: "wrapper-doc-demo-outer" }, [
                        _c(
                          "div",
                          { staticClass: "wrapper-doc-demo-inner" },
                          [
                            _c("printpurchase-view", {
                              staticClass: "print-template",
                              attrs: {
                                purchase: _vm.docInfo,
                                fontSize: _vm.settings.doc_template.font_size,
                                isFixedSignatureBottom:
                                  _vm.settings.doc_template
                                    .is_fixed_signature_bottom
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-4 text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-ligth",
                            staticStyle: { "background-color": "#ccc" },
                            on: { click: _vm.onClickPrint }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.testprint")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("i", { staticClass: "fas fa-print" })
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("BaseFormAction", {
            attrs: {
              textSubmit: _vm.$t("button.save"),
              isSubmitted: _vm.isSubmitted
            },
            on: { onSubmit: _vm.handleSubmit }
          }),
          _vm._v(" "),
          _c("BaseConfirmDiscardModal", {
            attrs: { show: _vm.confirmDiscardModal.show },
            on: {
              onCancel: _vm.handleDiscardCancleModal,
              onConfirm: _vm.handleDiscardConfirmModal
            }
          }),
          _vm._v(" "),
          _c("BaseModalCustomMasterData", {
            attrs: {
              list: _vm.settings.log_topic.options,
              id: _vm.MODAL_LOG_TOPIC_MASTER_DATA,
              headerText: _vm.$t("message.managetopicoptions"),
              showCheckboxDefault: false
            },
            on: {
              onClose: _vm.handleCloseLogTopicMasterData,
              onSubmit: _vm.handleSubmitLogTopicMasterData
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3eba854d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eba854d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/purchases/configuration/Setting.vue
// module id = null
// module chunks = 